<template>
  <div>
    <v-toolbar dark flat color="grey-lighten">
      <v-toolbar-title>Gestión de usuarios</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo</v-btn>

        <v-card>
          <v-card-title class="headline info">
            <span>{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="formularioUsuarioValido">
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Nombre completo"
                      v-model="editedItem.name"
                      :rules="soloTextoRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      label="Correo electrónico"
                      v-model="editedItem.email"
                      :rules="emailRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <h3>Roles</h3>
                    <v-select
                      v-model="editedItem.role"
                      :items="allRoles"
                      label="Roles"
                      item-text="name"
                      return-object
                      chips
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" @click="save" v-if="formularioUsuarioValido">Guardar</v-btn>
              <v-btn color="gray darken-1" disabled v-else>Guardar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-dialog v-model="dialogEliminar" persistent max-width="290">
      <v-card>
        <v-card-title class="headline info">Eliminar registro</v-card-title>

        <v-card-text>¿Está seguro de eliminar el registro?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" @click="dialogEliminar = false">Cancelar</v-btn>

          <v-btn color="green darken-1" @click="confirmDeleteItem">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogErrorEliminar" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline info">Eliminar registro</v-card-title>

        <v-card-text>No se puede eliminar este registro porque tiene información relacionada.</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" @click="dialogErrorEliminar = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="tableData" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs">{{ props.item.email }}</td>
        <td class="text-xs">
          <v-chip
            class="ma-2"
            color="blue accent-4"
            text-color="white"
            v-if="props.item.role"
          >{{ props.item.role.name }}</v-chip>
          <v-chip
            class="ma-2"
            color="orange accent-4"
            text-color="white"
            v-else
          >No tiene un rol asignado</v-chip>
        </td>
        <td>
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialogEliminar: false,
    dialogErrorEliminar: false,
    formularioUsuarioValido: true,
    soloTextoRules: [
      (v) =>
        /[a-zA-z]{2,}/.test(v) ||
        "Es un campo de texto obligatorio de mínimo 4 caracteres",
    ],
    emailRules: [
      (v) =>
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(v) ||
        "Debe digitar un correo electrónico válido",
    ],
    search: "",
    headers: [
      { text: "Nombre completo", value: "name" },
      { text: "Correo electrónico", value: "email" },
      { text: "Rol", value: "role", sortable: false },
      { text: "Acciones", value: "name", sortable: false },
    ],
    tableData: [],
    editedIndex: -1,
    allRoles: [],
    editedItem: {
      name: "",
      email: "",
      role: {},
    },
    defaultItem: {
      name: "",
      email: "",
      role: {},
      created_at: "",
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Formulario de creación"
        : "Formulario de edición";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      axios.get("/api/users").then((response) => {
        this.tableData = response.data.data;
      });
      axios
        .get("/api/roles")
        .then((response) => (this.allRoles = response.data.data));
    },
    editItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEliminar = true;
    },
    confirmDeleteItem() {
      axios
        .delete("/api/users/" + this.editedItem.id)
        .then((response) => {
          this.tableData.splice(this.editedIndex, 1);
        })
        .catch((error) => {
          this.dialogErrorEliminar = true;
        });
      this.dialogEliminar = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        axios
          .put("/api/users/" + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.tableData[this.editedIndex], response.data.data);
            this.close();
          });
      } else {
        axios.post("/api/users/", this.editedItem).then((response) => {
          this.tableData.push({
            ...response.data.user,
            role:
              response.data.user.roles && response.data.user.roles.length > 0
                ? response.data.user.roles[0]
                : "",
          });
          this.close();
        });
      }
    },
  },
};
</script>
